import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import TreatCard from "./TreatCard";
const treatList = [
  {
    id: "1",
    title: "Minimize Side Effects",
    text: "Designed to reduce systemic absorption, thus minimizing potential side effects commonly associated with hair loss treatments.",
    addClass: "topl",
  },
  {
    id: "2",
    title: "Enhanced Absorption",
    text: "The formulation promotes optimal absorption, significantly improving the efficacy of the treatment.",
    addClass: "topr right",
  },
  {
    id: "3",
    title: "Greater Comfort",
    text: "Patients see improved results due to the direct and efficient delivery of active ingredients.",
    addClass: "midl",
  },
  {
    id: "4",
    title: "Targeted Application",
    text: "Our technology facilitates precise delivery to the scalp, maximizing the effectiveness of active ingredients directly at the hair follicles.",
    addClass: "midr right",
  },
  {
    id: "5",
    title: "Consistent Outcomes",
    text: "Our delivery technology provides uniform distribution, ensuring consistent and reliable treatment outcomes for all patients.",
    addClass: "botl",
  },
  {
    id: "6",
    title: "Increased Efficacy",
    text: "Patients see improved results due to the direct and efficient delivery of active ingredients.",
    addClass: "botr right",
  },
];
export default function Treat() {
  const [modal, setModal] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [mobile, setMobile] = useState(false);
  useEffect(() => {
    if (window.innerWidth < 750) {
      setMobile(true);
    } else {
      setMobile(false);
    }
    window.addEventListener("resize", () => {
      if (window.innerWidth < 750) {
        setMobile(true);
      } else {
        setMobile(false);
      }
    });
  }, []);
  useEffect(() => {
    if (modal) {
      document.body.classList.add("active");
    } else {
      document.body.classList.remove("active");
    }
  }, [modal]);
  const closeFunc = (e) => {
    if (e.currentTarget === e.target) setModal(null);
  };
  return (
    <>
      <div className="anchor" id="treat" aria-hidden="true"></div>
      <section className="treat" aria-labelledby="treat-heading">
        <div className="auto__container">
          <div className="treat__inner">
            <div className="treat__inner-title">
              <h2 id="treat-heading">Innovative Edge</h2>
            </div>
            <div className="treat__inner-row">
              <div className="treat__inner-content">
                <h3 id="delivery-tech-heading">Drug Delivery Technology</h3>
                <p>
                  Proxium's innovative drug delivery platform stands as a
                  testament to our commitment to revolutionizing hair
                  restoration treatments. This proprietary technology ensures
                  that our therapeutic agents are delivered directly and
                  efficiently to the hair follicles, where they are most needed.
                </p>
              </div>
              <div className="treat__inner-image" aria-hidden="true">
                <img className="desc" src="/images/treat/shape-1.png" alt="Proxium's drug delivery technology illustration - desktop view" />
                <img className="mob" src="/images/treat/circle-1.png" alt="Proxium's drug delivery technology illustration - mobile view" />
              </div>
            </div>
            <div className="treatMain">
              <div className="treatMain__title">
                <hr />
                <h3 id="key-features-heading">Key Features</h3>
                <hr />
              </div>
              <div className="treatMain__content">
                <div className="treatMain__image">
                  <img src="/images/treat/1.png" alt="Visual representation of Proxium's key technology features" />
                </div>
                <div className="treatMain__list" role="list">
                  {treatList.map((item, index) => {
                    return (
                      <TreatItem
                        mobile={mobile}
                        onClick={() => {
                          setModal(true);
                          setModalData(item);
                        }}
                        {...item}
                        key={index}
                      />
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <AnimatePresence>
        {modal && <TreatCard closeFunc={closeFunc} setModal={setModal} modalData={modalData} />}
      </AnimatePresence>
    </>
  );
}
const TreatItem = (props) => {
  const [active, setActive] = useState(false);
  return (
    <div
      className={"treatItem " + (props.addClass ? props.addClass : "")}
      role="listitem"
    >
      <div
        className="treatItem__title"
        onClick={() => {
          if (props.mobile) {
            props.onClick();
          } else {
            setActive(!active);
          }
        }}
        role="button"
        aria-expanded={active}
        aria-controls={`treat-item-${props.id}-content`}
        tabIndex="0"
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            if (props.mobile) {
              props.onClick();
            } else {
              setActive(!active);
            }
            e.preventDefault();
          }
        }}
      >
        <h4 id={`treat-item-${props.id}-title`}>{props.title}</h4>
        <span aria-hidden="true"></span>
      </div>
      <AnimatePresence>
        {active && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.2 }}
            exit={{ opacity: 0 }}
            className="treatItem__body"
            id={`treat-item-${props.id}-content`}
            aria-labelledby={`treat-item-${props.id}-title`}
          >
            <p className="sm">{props.text}</p>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};
